module.exports = __webpack_public_path__ + "img/chinesecompany127.7af82731.png";